import classNames from 'classnames';
import CheckIcon from '@heroicons/react/24/solid/CheckIcon';
import XMarkIcon from '@heroicons/react/24/solid/XMarkIcon';
import ExclamationTriangleIcon from '@heroicons/react/24/outline/ExclamationTriangleIcon';
import { OptionType } from '../../../api/student-question';

export type QuestionOptionsPropsType = {
  options: OptionType[];
  selectedOptionId: number | null;
  showAnswer: boolean;
};

function QuestionOptions({ options, selectedOptionId, showAnswer }: QuestionOptionsPropsType) {
  return (
    <div className='flex flex-col gap-2 py-3'>
      {options.map(option => {
        const color = !showAnswer
          ? 'white'
          : !selectedOptionId
          ? 'yellow'
          : option.isCorrect
          ? 'green'
          : 'red';

        return (
          <div
            key={option.id}
            className={classNames(
              'align-center flex cursor-not-allowed select-none rounded-md border-2 p-3',
              {
                [`border-${color}-400 bg-${color}-50`]:
                  option.id === selectedOptionId || option.isCorrect
              }
            )}
          >
            {option.text.startsWith('<') ? (
              <div dangerouslySetInnerHTML={{ __html: option.text }} className='ck-content' />
            ) : (
              <div className='select-none'>{option.text}</div>
            )}
            {showAnswer && option.isCorrect && !selectedOptionId && (
              <ExclamationTriangleIcon
                width={25}
                height={25}
                className={`ms-auto shrink-0 stroke-current text-yellow-600`}
              />
            )}
            {showAnswer &&
              option.id === selectedOptionId &&
              (option.isCorrect ? (
                <CheckIcon
                  width={25}
                  height={25}
                  className={`ms-auto shrink-0
               rounded-lg border-2
               border-green-500 stroke-current text-green-500`}
                />
              ) : (
                <XMarkIcon
                  width={25}
                  height={25}
                  className={classNames(
                    `ms-auto shrink-0
               rounded-lg border-2
               border-red-500 stroke-current text-red-500`
                  )}
                />
              ))}
          </div>
        );
      })}
    </div>
  );
}

export default QuestionOptions;
